import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: '프로젝트', href: '#portfolio' },
    { name: '서비스', href: '#services' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <span className={`text-xl font-light tracking-wider ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              <span className="font-bold">P</span>.collective
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) =>
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className={`text-sm tracking-widest transition-colors cursor-pointer ${
                    isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                  }`}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className={`text-sm tracking-widest transition-colors cursor-pointer ${
                    isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                  }`}
                >
                  {link.name}
                </a>
              )
            )}
          </div>

          <a
            href="https://form.naver.com/response/XAc4kYKR-2Wg14KJ-ilzcQ"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hidden lg:block px-6 py-3 bg-[#D97757] text-white text-sm tracking-wide rounded-full hover:bg-[#C86647] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            상담 예약하기
          </a>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center ${isScrolled ? 'text-gray-900' : 'text-white'}`}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) =>
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block text-gray-700 hover:text-gray-900 cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-gray-700 hover:text-gray-900 cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              )
            )}
            <a
              href="https://form.naver.com/response/XAc4kYKR-2Wg14KJ-ilzcQ"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="block w-full text-center px-6 py-3 bg-[#D97757] text-white rounded-full cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              상담 예약하기
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
